<template>
  <div class="course-card d-flex flex-column" :class="{ selected: isSelected }">
    <img
      v-if="course.image_url"
      class="course-image"
      :src="course.image_url"
      :alt="course.course_name"
    />
    <img
      v-else
      class="course-image"
      src="../../assets/images/course.png"
      :alt="course.course_name"
    />
    <h3 class="course-name">{{ course.course_name }}</h3>
    <div class="course-info d-flex justify-content-between align-items-center">
      <div class="d-flex gap-1 align-items-center">
        <img class="tutor-image" v-if="course.image_url" :src="course.image_url" :alt="course.title" />
        <img class="tutor-image" v-else src="../../assets/images/course.png" :alt="course.title" />
        <h4 class="tutor-name m-0">{{ course.title }}</h4>
      </div>
      <div class="d-flex gap-1 align-items-center pills">
        <span class="pill">{{ course.course_type_name }}</span>
      </div>
    </div>
    <p class="course-desc">
      {{ courseDescription }}
    </p>
    <button class="mt-auto select-btn" @click.stop.prevent="selectCourse">
      {{ $t(isSelected ? "unselect" : "select") }}
    </button>
  </div>
</template>

<script>
import GlobalMixin from "../../GlobalMixin";

export default {
  name: "CourseCard",
  mixins: [GlobalMixin],
  props: {
    course: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      maxSelectedCourses: 3,
    };
  },
  methods: {
    /**
     * Select course, emits an event and change button Text
     */
    selectCourse() {
      if (this.isSelected)
        return this.$store.dispatch("removeSelectedKidsCourse", this.course.id);
      if (this.selectedCourses.length === this.maxSelectedCourses)
        return this.showAlert(
          `You can choose only up to ${this.maxSelectedCourses} courses!`,
          "error"
        );
      return this.$store.dispatch("saveSelectedKidsCourse", {
        id: this.course.id,
        user: this.$store?.getters?.StateUser?.user?.id,
        course: this.course,
        tutor: this.course.associated_tutors,
      });
    },
  },
  computed: {
    /**
     * Get all selected courses ids
     */
    selectedCourses() {
      return this.$store.getters.GET_SELECTED_KIDS_COURSES;
    },

    /**
     * Check if course is selected or not
     */
    isSelected() {
      return this.selectedCourses.find((c) => c.course.id === this.course.id);
    },

    /**
     * Get course description and slice it if it more than the height of course card
     * @returns string
     */
    courseDescription() {
      return this.course.description.length > 150
        ? `${this.course.description.slice(0, 150)}...`
        : this.course.description;
    },
  },
};
</script>

<style lang="scss" scoped>
.course-card {
  outline: 1px solid #b4bbc5;
  border-radius: 8px;
  padding: 12px;
  font-family: $font-family;
  font-style: normal;
  text-decoration: none;
  color: $black;
  font-size: 16px;
  background: $white;
  height: 405px;

  &:hover,
  &.selected {
    background: #e7f5e8;
    outline: 2px solid #5fd068;
  }

  .course-image {
    width: 100%;
    height: 205px;
    border-radius: 8px;
    margin-bottom: 12px;
  }

  .course-name {
    font-weight: 500;
    font-size: 1em;
    line-height: 1.5em;
    color: #061c3d;
  }

  .course-info {
    margin-bottom: 8px;
    .tutor-image {
      width: 28px;
      height: 28px;
      border-radius: 50%;
      object-fit: cover;
    }
    .tutor-name {
      font-weight: 500;
      font-size: 0.875em;
      line-height: 1.5em;
      color: #061c3d;
    }
    .pills {
      .pill {
        min-width: 38px;
        background: $white;
        border: 1px solid #0f9918;
        border-radius: 100px;
        padding: 4px;
        font-weight: 300;
        font-size: 0.75em;
        color: #0f9918;
      }
    }
  }
  .course-desc {
    font-weight: 300;
    font-size: 0.75em;
    line-height: 1.25em;
    color: $description;
    font-style: normal;
    margin-bottom: 8px;
  }
  .select-btn {
    background: $green;
    border-radius: 8px;
    padding: 8px;
    font-weight: 500;
    font-size: 0.825em;
    line-height: 1.5em;
    color: $white;
    &:hover {
      background: $hover-green;
    }
  }
}

@media all and (max-width: $min-md-screen) {
  .course-card {
    .course-image {
      height: 138px;
    }
  }
}
</style>
